module.exports = __webpack_public_path__ + "img/background-video-slider-v2-default.bdcfe668.png";